module.exports = "/img/item-8.c7debd95.png";